<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base position-relative top-119">
    <div class="container pt-32 pb-5">
      <h1 class="text-white h1-size">Joalharia</h1>
    </div>
    <div class="container">
      <div class=" row d-flex justify-content-center">
        <ng-container *ngFor="let item of marcasJoia">
          <a class="card m-1 grayscale clock-expand clock-shadow-card" href="{{link(item)}}">
            <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top grayscale" alt="...">
          </a>
        </ng-container>
      </div>
    </div>
    <div class="container pt-5">
      <h1 class="text-white h1-size">Pratas</h1>
    </div>
    <div class="container">
      <div class=" row d-flex justify-content-center pb-20">
        <ng-container *ngFor="let item of marcasPrata">
          <a class="card m-1 grayscale clock-expand clock-shadow-card pointer" href="{{link(item)}}">
            <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top grayscale" alt="...">
          </a>
        </ng-container>
      </div>
    </div>
  </section>
</div>